module.exports = __webpack_public_path__ + "img/TZS09428.248b7690.jpeg";